/**
 * This reducer is used for validating products while adding to cart
 */
import {
    VALIDATE_PRODUCTS,
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
    CLEAR_VALIDATED_PRODUCTS,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';

const initialState = {
    validatedProducts: [],
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const ValidateProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                loading: true,
                statusCode: 0,
            };
        case VALIDATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                validatedProducts: [...action.validatedProducts],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case VALIDATE_PRODUCTS_FAILURE:
            return {
                ...state,
                validatedProducts: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case CLEAR_VALIDATED_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
            };

        default: {
            return { ...state };
        }
    }
};

export default ValidateProductsReducer;
